import { PricingPlan } from "@/primary-models";

export const PRICING_PLAN_QUANTITY = {
  [PricingPlan.SAVER]: 42,
  [PricingPlan.STANDARD]: 28,
  [PricingPlan.HALF]: 28,
  [PricingPlan.FREEZER]: 14,
  [PricingPlan.TRIAL]: 14,
};

export const PRICING_PLAN_CADENCE = {
  [PricingPlan.SAVER]: 42,
  [PricingPlan.STANDARD]: 28,
  [PricingPlan.HALF]: 56,
  [PricingPlan.FREEZER]: 14,
  [PricingPlan.TRIAL]: 14,
};
